import { API } from "./api";
import axios from "axios";

export function trackVisit(path = "/") {
  try {
    const key = `rp_tracked_${path}`;
    const last = sessionStorage.getItem(key);
    if (last && Date.now() - Number(last) < 60000) return;
    sessionStorage.setItem(key, String(Date.now()));
    let vid = localStorage.getItem("rp_visitor_id");
    if (!vid) {
      vid = crypto.randomUUID();
      localStorage.setItem("rp_visitor_id", vid);
    }
    axios.post(`${API}/track`, { visitor_id: vid, path }).catch(() => {});
  } catch (e) {
    /* tracking is best-effort */
  }
}
